export const DATE_FORMAT = {
  YMD: 'YYYY-MM-DD', // 2025-01-01
  MONTH_YEAR: 'MMM YYYY', // Jan 2025
  FULL: 'MMMM D, YYYY', // January 1, 2025
  FULL_WITH_TIME: 'MMMM D, YYYY [at] h:mm A', // January 1, 2025 at 12:00 AM
  SHORT: 'MMM DD, YYYY', // Jan 01, 2025
  SHORT_NO_PAD: 'MMM D, YYYY', // Jan 1, 2025
  SHORT_WITH_TIME: 'MMM D, YYYY [at] h:mm A', // Jan 1, 2025 at 12:00 AM
  MONTH_DAY: 'MMM D', // Jan 1
  DAY_YEAR: 'D, YYYY', // 1, 2025
  TIME: 'h:mm A', // 12:00 AM
  MONTH_DAY_WITH_TIME: 'MMM D [at] h:mm A', // Jan 1 at 12:00 AM
  YEAR: 'YYYY', // 2025
};
